/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RubricGenerationInput } from './rubricGenerationInput';

export type BodyGenerateTaskRubricTaskAnalysis = RubricGenerationInput | null;
